export default __webpack_public_path__ + "static/media/60.4a17b6a3.jpeg";